var exports = {
  "kL": "ChannelDivider.module__container___Q0Mzbm",
  "JW": "ChannelDivider.module__unreadContainer___Q0Mzbm",
  "iN": "ChannelDivider.module__unreadDate___Q0Mzbm",
  "n8": "ChannelDivider.module__line___Q0Mzbm",
  "Qq": "ChannelDivider.module__text___Q0Mzbm",
  "KQ": "ChannelDivider.module__unreadLine___Q0Mzbm",
  "vD": "ChannelDivider.module__dateWithUnreadText___Q0Mzbm",
  "HN": "ChannelDivider.module__unreadBadge___Q0Mzbm",
};

module.exports = exports;
